<template>
  <div
    class="border-gray -ml-4 -mr-4 flex w-screen flex-col items-start border-b bg-white p-4 shadow-md md:rounded-md"
  >
    <h4 class="mb-4 text-left text-2xl text-dark-blue">Find Loads</h4>

    <div class="relative mb-4 flex w-full flex-col">
      <div class="flex">
        <div class="flex-4 dashboard-origin-location grow-[4]">
          <LocationSearchInput
            type="origin"
            class="flex-4"
            placeholder="Search an Origin"
            :input-value="filters.origin"
            :show-icons="false"
            :show-clear-icon="true"
            :is-slim="false"
            @set-location="setOriginFilters"
            @set-selected-location="setSelectedOrigin"
          ></LocationSearchInput>
        </div>

        <div
          class="dashboard-origin-dropdown relative w-full min-w-[90px] flex-1"
        >
          <dropdown-select
            :options="deadheadOptions"
            :default="selectedOriginDeadhead"
            :exclude-selected="true"
            class="deadhead-dropdown !h-12 border border-light-gray !bg-lighter-gray !bg-opacity-30 text-xs"
            @input="handleOriginDeadheadSelected"
          />
        </div>
      </div>

      <div class="flex">
        <div class="flex-4 dashboard-destination-location grow-[4]">
          <LocationSearchInput
            type="destination"
            placeholder="Search a Destination"
            :input-value="filters.destination"
            :show-icons="false"
            :show-clear-icon="true"
            :is-slim="false"
            @set-location="setDestinationFilters"
            @set-selected-location="setSelectedDestination"
          ></LocationSearchInput>
        </div>

        <div
          class="dashboard-destination-dropdown relative w-full min-w-[90px] flex-1"
        >
          <dropdown-select
            :options="deadheadOptions"
            :default="selectedDestinationDeadhead"
            :exclude-selected="true"
            class="deadhead-dropdown !h-12 border border-light-gray !bg-lighter-gray !bg-opacity-30 text-xs"
            @input="handleDestinationDeadheadSelected"
          />
        </div>
      </div>

      <!-- <div
        class="absolute right-2 top-4 cursor-pointer rounded-full border border-light-gray bg-white p-2"
        @click="toggleLocationInputOrder"
      >
        <img
          class=""
          src="@/assets/arrows-up-and-down.svg"
          alt="arrows icon"
        />
      </div> -->
    </div>

    <div
      class="equipment-dropdown flex w-full items-center justify-between gap-3"
    >
      <dropdown-select
        :options="equipmentOptions"
        :default="selectedEquipment"
        :value="selectedEquipment"
        :exclude-selected="true"
        class="mt-6 !h-12 flex-1 border border-light-gray !bg-lighter-gray !bg-opacity-30 text-xs"
        @input="handleSelectedEquipment"
      />

      <div class="relative w-full flex-1">
        <form-field-date
          label=" "
          :hide-label="true"
          class="!mt-0 !h-12"
          placeholder="Pickup Date"
          :model-value="selectedPickupDate"
          name="pickup_date"
          input-type="date"
          :isSlim="true"
          :hidden="false"
          :monospace="false"
          :show-confirm-button="false"
          @update:model-value="dynamicUpdatePickupDate"
          @toggle-date-picker="toggleShowPickupDatePicker"
        />
        <div
          v-show="showPickupDatePicker"
          class="absolute -bottom-20 right-5 z-50 rounded-lg bg-white p-4 shadow-md"
        >
          <date-picker
            :initial-date="initialDate"
            :field="'pickup_datepicker'"
            date-format="MM/DD/YYYY"
            :handle-input="setSelectedPickupDay"
            @day-selected="setSelectedPickupDay"
          />
        </div>
      </div>
    </div>

    <div class="mt-4 w-full">
      <button-main
        class="flex !h-[48px] items-center justify-center gap-2 !py-3 text-1md !text-dark-gray"
        :disabled="isSearchDisabled"
        @click="handleSearch"
      >
        <img
          class=""
          src="@/assets/magnifying-glass-black.svg"
          alt="magnifying glass"
        />
        Search
      </button-main>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import dayjs from 'dayjs';
import LocationSearchInput from '@/components/loads/LocationSearchInput.vue';
import DropdownSelect from '@/components/loads/LoadDropdown.vue';
import ButtonMain from '@/components/Button.vue';
import FormFieldDate from '@/components/FormFieldDate.vue';
import DatePicker from '@/components/DatePicker.vue';
import { createFilterQuery } from '@/utils/loadFilters.js';

export default {
  name: 'DashboardLoadSearch',
  components: {
    LocationSearchInput,
    ButtonMain,
    DropdownSelect,
    FormFieldDate,
    DatePicker,
  },
  data() {
    return {
      deadheadOptions: [
        '50 Mi',
        '100 Mi',
        '150 Mi',
        '200 Mi',
        '250 Mi',
        '300 Mi',
        '350 Mi',
        '400 Mi',
        '450 Mi',
        '500 Mi',
      ],
      equipmentOptions: ['All', 'Flatbed', 'Power Only', 'Reefer', 'Van'],
    };
  },
  setup() {
    const router = useRouter();
    const store = useStore();

    const filters = ref({
      origin: '',
      destination: '',
      selectedOrigin: '',
      selectedDestination: '',
      deadhead: '',
      city_state_origin: '',
      city_state_destination: '',
      origin_deadhead: '50',
      destination_deadhead: '50',
      equipment: [],
    });

    const isSearchDisabled = computed(() => !filters.value?.origin?.length);

    const selectedOriginDeadhead = ref('');
    const selectedDestinationDeadhead = ref('');
    const handleOriginDeadheadSelected = (item) => {
      console.log('select deadhead', item);
      const origin = item?.split(' ')?.[0];
      filters.value.origin_deadhead = origin;
    };
    const handleDestinationDeadheadSelected = (item) => {
      console.log('select deadhead', item);
      const destination = item?.split(' ')?.[0];
      filters.value.destination_deadhead = destination;
    };

    const setOriginFilters = (origin) => {
      filters.value.origin = origin;
    };

    const setDestinationFilters = (destination) => {
      filters.value.destination = destination;
    };

    const setSelectedOrigin = (origin) => {
      filters.value.origin_area_id = origin?.id;
      filters.value.selectedOrigin = origin?.code;
    };

    const setSelectedDestination = (destination) => {
      filters.value.destination_area_id = destination?.id;
      filters.value.selectedDestination = destination?.code;
    };

    const equipmentMap = {
      Flatbed: 'flatbed',
      'Power Only': 'power_only',
      Reefer: 'reefer',
      Van: 'van',
    };

    const selectedEquipment = ref('All');
    const handleSelectedEquipment = (item) => {
      selectedEquipment.value = `Equipment: ${item}`;
      console.log('select equipment', item);

      if (item !== 'All') {
        filters.value.equipment = [equipmentMap[item]];
      }
    };

    const initialDate = computed(() => {
      return dayjs().format('MM/DD/YYYY');
    });
    const selectedPickupDate = ref(filters.value.pickup_start || '');
    const showPickupDatePicker = ref(false);

    const toggleShowPickupDatePicker = () => {
      showPickupDatePicker.value = !showPickupDatePicker.value;
    };

    function dynamicUpdatePickupDate({ value }) {
      if (value) {
        filters.value.pickup_start = selectedPickupDate.value;
      }
    }

    function setSelectedPickupDay(fieldValue, dateSelected) {
      if (fieldValue) {
        selectedPickupDate.value = dayjs(dateSelected).format('MM/DD/YYYY');
        dynamicUpdatePickupDate({ name: fieldValue, value: dateSelected });
        showPickupDatePicker.value = false;
      }
    }

    const handleSearch = async () => {
      console.log('handle search:');

      // set localstorage after search
      const existingLoadSearchStorage =
        JSON.parse(localStorage.getItem('recent_load_searches')) || [];

      const trimmedOrigin =
        filters.value?.origin?.match(/^.*?,\s?[A-Z]{2}/)?.[0];
      const trimmedDestination =
        filters.value?.destination?.match(/^.*?,\s?[A-Z]{2}/)?.[0];

      // Add new search item
      existingLoadSearchStorage.unshift({
        ...filters.value,
        origin: trimmedOrigin,
        destination: trimmedDestination,
      });

      const lastestFourStorageItems = existingLoadSearchStorage.slice(0, 4);

      // Save back to localStorage
      localStorage.setItem(
        'recent_load_searches',
        JSON.stringify(lastestFourStorageItems)
      );

      await store.commit('loads/setLoads', []);
      await store.commit('loads/setLoadSearchFilters', filters.value);

      const params = createFilterQuery(
        filters.value,
        router.currentRoute.value.query
      );

      // redirect to load-board route
      await router.push({
        name: 'Load Board',
        query: params,
      });
    };

    const toggleLocationInputOrder = () => {
      const previousOrigin = filters.value.origin;
      const previousDestination = filters.value.destination;
      const previousSelectedOrigin = filters.value.selectedOrigin;
      const previousSelectedDestination = filters.value.selectedDestination;

      filters.value.origin = previousDestination;
      filters.value.destination = previousOrigin;
      filters.value.selectedOrigin = previousSelectedDestination;
      filters.value.selectedDestination = previousSelectedOrigin;
    };

    return {
      filters,
      handleSearch,
      isSearchDisabled,
      setOriginFilters,
      setSelectedOrigin,
      setDestinationFilters,
      setSelectedDestination,
      selectedOriginDeadhead,
      toggleLocationInputOrder,
      selectedDestinationDeadhead,
      handleOriginDeadheadSelected,
      handleDestinationDeadheadSelected,
      initialDate,
      selectedPickupDate,
      showPickupDatePicker,
      toggleShowPickupDatePicker,
      dynamicUpdatePickupDate,
      setSelectedPickupDay,
      selectedEquipment,
      handleSelectedEquipment,
    };
  },
};
</script>

<style>
.deadhead-dropdown > div {
  @apply w-full;
}

.equipment-dropdown > div {
  @apply my-0 rounded-lg;
}

.dashboard-origin-location input {
  @apply rounded-lg rounded-r-none rounded-bl-none;
}
.dashboard-origin-dropdown > div {
  @apply my-0 rounded-lg rounded-l-none rounded-br-none;
}
.dashboard-origin-dropdown > div > div:first-of-type,
.dashboard-destination-dropdown > div > div:first-of-type,
.equipment-dropdown > div > div:first-of-type {
  @apply bg-opacity-30;
}

.dashboard-destination-location input {
  @apply rounded-lg rounded-r-none rounded-tl-none;
}
.dashboard-destination-dropdown > div {
  @apply my-0 rounded-lg rounded-l-none rounded-tr-none;
}

.equipment-dropdown input {
  @apply h-12 border border-light-gray bg-opacity-30;
}
</style>
